module.exports = __webpack_public_path__ + "img/croatia.03c731ab.svg";